import apiClient from '../../../utilities/apiClient.js';

export const projectList = (payload) => {
  return apiClient.get(`${apiClient.Urls.projectList}`, payload, true);
};

export const locations = (payload) => {
  return apiClient.get(`${apiClient.Urls.locations}`, payload, true);
};

export const bbsCreate = (payload) => {
  return apiClient.post(`${apiClient.Urls.bbsCreate}`, payload, true);
};

export const bbsList = ({ currentPage, pageSize }) => {
  return apiClient.get(
    `${apiClient.Urls.bbsList}?page=${currentPage}&limit=${pageSize}`,
    true,
  );
};

export const projectCount = (payload) => {
  return apiClient.get(`${apiClient.Urls.projectCount}`, payload, true);
};

export const approverDashboard = (payload) => {
  const { userId, page, search, month_array } = payload; // Extract search from payload
  let url = month_array
    ? `${apiClient.Urls.approverDashboard}/?page=${page}&month_array=${month_array}`
    : `${apiClient.Urls.approverDashboard}/?page=${page}`;

  if (search) {
    url += `&search=${encodeURIComponent(search)}`; // Add search query if present
  }

  return apiClient.post(url, { userId }, true);
};

export const viewProject = (projectCode) => {
  return apiClient.get(
    `${apiClient.Urls.viewProject}/${projectCode}`,
    null,
    true,
  );
};

export const managerDashboard = (payload = {}) => {
  console.log("Payload received in API:", payload); // 🔍 Debugging log

  if (!payload.manager_id) {
    throw new Error("Manager ID is required");
  }

  const { page = 1, search = "", manager_id } = payload; // ✅ Default values
  let url = `${apiClient.Urls.managerDashboard}/?page=${page}&manager_id=${manager_id}`;
  if (search) {
    url += `&search=${encodeURIComponent(search)}`;
  }

  console.log("Final API URL:", url); // 🔍 Debugging log
  return apiClient.get(url);
};


export const managerApproveProject = (payload) => {
  return apiClient.post(
    `${apiClient.Urls.managerApproveProject}`,
    payload,
    true,
  );
};

export const managerApproveUser = (payload) => {
  return apiClient.post(`${apiClient.Urls.managerApproveUser}`, payload, true);
};

export const fetchApproveReject = (payload) => {
  return apiClient.get(
    `${apiClient.Urls.fetchApproveReject}/${payload}`,
    payload,
    true,
  );
};

export const newBBS = (payload) => {
  const { userId, page ,search} = payload;
  return apiClient.post(
    `${apiClient.Urls.newBBS}?page=${page}&search=${search || ""}`,
    { userId }, // Send userId in the request body (payload)
    true,
  );
};

export const BBSView = (payload) => {
  return apiClient.get(`${apiClient.Urls.BBSView}/${payload}`, null, true);
};

export const projectCountDashboard = (payload) => {
  return payload.month_array
    ? apiClient.post(
        `${apiClient.Urls.projectCountDashboard}?month_array=${payload.month_array}`,
        payload,
        true,
      )
    : apiClient.post(`${apiClient.Urls.projectCountDashboard}`, payload, true);
};

export const optimizationCountDashboard = (payload) => {
  return payload.month_array
    ? apiClient.post(
        `${apiClient.Urls.optimizationCountDashboard}?month_array=${payload.month_array}`,
        payload,
        true,
      )
    : apiClient.post(
        `${apiClient.Urls.optimizationCountDashboard}`,
        payload,
        true,
      );
};

export const managerProjectCountDashboard = ({ manager_id }) => {
  return apiClient.get(
    `${apiClient.Urls.managerProjectCountDashboard}?manager_id=${manager_id}`,
    true
  );
};

export const managerOptimizationCountDashboard = ({ manager_id }) => {
  return apiClient.get(
    `${apiClient.Urls.managerOptimizationCountDashboard}?manager_id=${manager_id}`,
    true
  );
};
export const bbsInactivate = (params) => {
  const queryString = Object.keys(params)
    .map(
      (key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`,
    )
    .join('&');
  return apiClient.get(`${apiClient.Urls.bbsInactivate}?${queryString}`, true);
};

export const getBbs = (params) => {
  const queryString = Object.keys(params)
    .map(
      (key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`,
    )
    .join('&');
  return apiClient.get(`${apiClient.Urls.getBbs}?${queryString}`, true);
};

export const leaderShipDashboard = (params) => {
  const queryString = Object.keys(params)
    .map((key) => {
      const value = params[key];
      return `${encodeURIComponent(key)}=${encodeURIComponent(
        typeof value === 'object' ? JSON.stringify(value) : value,
      )}`;
    })
    .join('&');

  return apiClient.get(
    `${apiClient.Urls.leaderShipDashboard}?${queryString}`,
    true,
  );
};


export const leaderShipDashboard_MANAGER = (params) => {
  const queryString = Object.keys(params)
    .map((key) => {
      const value = params[key];
      return `${encodeURIComponent(key)}=${encodeURIComponent(
        typeof value === 'object' ? JSON.stringify(value) : value,
      )}`;
    })
    .join('&');

  return apiClient.get(
    `${apiClient.Urls.leaderShipDashboard_manager}?${queryString}`,
    true,
  );
};

// export const leaderShipDashboard = (payload) => {
//   return apiClient.get(`${apiClient.Urls.leaderShipDashboard}`, payload, true);
// };

export const leaderShipTableData = (payload) => {
  return apiClient.post(`${apiClient.Urls.leaderShipTableData}`, payload, true);
};

export const leaderShipManagerTableData = (params) => {
  const queryString = Object.keys(params)
    .map((key) => {
      const value = params[key];
      return `${encodeURIComponent(key)}=${encodeURIComponent(
        typeof value === 'object' ? JSON.stringify(value) : value,
      )}`;
    })
    .join('&');

  return apiClient.get(
    `${apiClient.Urls.leaderShipManagerTableData}?${queryString}`,
    true,
  );
};

export const finalBBSOutput = (params) => {
  const queryString = Object.keys(params)
    .map(
      (key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`,
    )
    .join('&');
  return apiClient.get(`${apiClient.Urls.finalBBSOutput}?${queryString}`, true);
};

export const inputFiles = (params) => {
  const queryString = Object.keys(params)
    .map(
      (key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`,
    )
    .join('&');
  return apiClient.get(`${apiClient.Urls.inputFiles}?${queryString}`, true);
};
